<script>
import PInput from '../p-input.vue'
import PSelect from '../p-select.vue'
import PCard from '../p-card.vue'
import userService from '../../services/user.js'
import {validate} from '../../utils/'

export default {
    name: "p-user-update",
    components:{
        PInput,
        PSelect,
        PCard
    },
    data() {
        return {
            errors: [],
            success:false,
            submitDisabled: false,
            successMessage : "default",
            user : {
                name : "",
                printName : "",
                cpf : "",
                rg : "",
                phone : "",
                celphone : "",
                email : "",
                site : "",
                type : "",
                photo : ""
            },
        }
    },
    methods: {
        submit(e){
            this.errors = [];
            this.success = false;
            this.submitDisabled = true;
            this.validate(e);
            if (!this.errors.length) {
                userService.update(this.user)
                .then(response => {
                    this.submitDisabled = false;
                    if (!response.data.erro) {
                        this.success = true;
                        this.successMessage = response.data.mensagem;
                    }else {
                        this.success = false;
                        this.errors.push(response.data.mensagem);
                    }
                }, err => {
                console.log(err);
                })
            } else {
                this.submitDisabled = false;
            }
        },

        validate(e) {
            // o modulo de validacao era em outro formato anteriormente, com a atualizacao
            // é necessário converter de object para array, pois anteriormente era array :/
            let errors = {};
            errors = validate(e);
            if (!!Object.keys(errors).length) {
                for (let error in errors) {
                    if (errors.hasOwnProperty(error)) {
                        this.errors.push(errors[error]);
                    }
                }
            }
        },
    },
    created: function() {
        let self = this;
        userService.get().then(res => {
            self.user.name = res.data.nome;
            self.user.printName = res.data.nome_impressao;
            self.user.cpf = res.data.cpf;
            self.user.rg = res.data.rg;
            self.user.phone = res.data.fone1;
            self.user.celphone = res.data.fone2;
            self.user.email = res.data.email;
            self.user.site = res.data.site;
            self.user.type = res.data.tipo;
            self.user.photo = res.data.foto
        }).catch(err => {
            console.log(err);
        })
    }
}
</script>
<template>
    <div class="wrapper">
       <transition name="fade">
           <ul class="messages" v-if="errors.length || success">
              <h1>{{errors.length?'Ops.': ':)'}}</h1>
              <li v-if="errors.length" v-for="e in errors" class="d-flex align-items-center">
                 <i class="p-icon error rouded mr-1">
                    <svg class="icon"><use xlink:href="#sprite-error"/></svg>
                 </i>
                 <span>{{e}}</span>
              </li>
              <li v-if="success && errors.length == 0" class="d-flex flex-align-center">
                 <i class="p-icon success rouded mr-1">
                    <svg class="icon"><use xlink:href="#sprite-success"/></svg>
                 </i>
                 <span>{{successMessage}}</span>
              </li>
           </ul>
       </transition>

       <p-card>
           <h4>Atualizar informações do perfil</h4>
           <h5>Preencha os campos abaixo e clique em salvar</h5>
           <br>
          <form action="" @submit.prevent="submit" class="p-form" novalidate>
             <div class="fields">
                <div class="form-inline">
                   <p-input name="name" required="true" minlength="3" label="Nome" type="text" v-model="user.name"></p-input>
                </div>

                <div class="form-inline">
                   <p-input name="printName" required="true" minlength="3" label="Nome impressos nos relatórios" type="text" v-model="user.printName"></p-input>
                </div>

                <div class="form-inline">
                   <p-input name="cpf" mask="###.###.###-##" label="CPF" type="text" v-model="user.cpf"></p-input>
                   <p-input name="rg" mask="##########" label="RG" type="text" v-model="user.rg"></p-input>
                   <p-input name="phone" mask="(##) ####-####" label="Telefone" type="tel" v-model="user.phone"></p-input>
                   <p-input name="celphone" mask="(##) #####-#####" label="Celular" type="tel" v-model="user.celphone"></p-input>
                </div>

                <div class="form-inline">
                   <p-input name="email" required="true" validate="email" label="Email" type="text" v-model="user.email"></p-input>
                   <p-input name="site" label="Site" type="text" v-model="user.site" v-if="user.type == 10"></p-input>
                </div>

             </div>
             <div class="footer p-2 d-flex justify-content-end align-items-center">
                 <a href="editar-usuario.php" class="btn btn-primary" name="button" title="Voltar" style="margin-right : 8px"><span class="text">Voltar</span></a>
                 <button type="submit" :disabled="submitDisabled" class="btn btn-primary" name="button" title="Cadastrar"><span class="text">Salvar</span></button>
             </div>
          </form>
       </p-card>
    </div>
</template>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/js/components/profile/p-user-update.vue